import $ from 'jquery'
const isMobile = () => {
  var windowSize = window.innerWidth;
  return windowSize <= 991 ? true : false;
}
const isDesktop = () => {
  var windowSize = window.innerWidth;
  return windowSize <= 1400 ? true : false;
}
const isWidescreen = () => {
  var windowSize = window.innerWidth;
  return windowSize > 1400 ? true : false;
}

const getSidebarStatus = () => {
  const status = $('#sidebar').hasClass('mobile-show') ? 'expanded' : 'collapsed';
  console.log(status);
  return status;
}

const toggleSidebar = (sidebar='#sidebar',action='toggle') => {
  const isMainSidebar = sidebar === '#sidebar' ? true : false;
  const isOverlaySidebar = $(sidebar).hasClass('sidebar--overlay') ? true : false;
  switch (action){
    case 'hide':
      $(sidebar).removeClass('sidebar--expanded').addClass('sidebar--collapsed');
      if (isMainSidebar) $('body').removeClass('has-sidebar-expanded').addClass('has-sidebar-collapsed');
      $('body').attr('sidebar-active', '').removeClass('has-sidebar-overlaid');  
      break;
    case 'show':
      isOverlaySidebar ? $('body').addClass('has-sidebar-overlaid') : $('body').removeClass('has-sidebar-overlaid');
      $(sidebar).addClass('sidebar--expanded').removeClass('sidebar--collapsed');
      if (isMainSidebar) $('body').addClass('has-sidebar-expanded').removeClass('has-sidebar-collapsed')
      $('body').attr('sidebar-active', sidebar);  
      break;
    case 'toggle':
    default:
      // $('.sidebar:not('+sidebar+')').removeClass('sidebar--expanded').addClass('sidebar--collapsed'); // Hides other sidebars
      $(sidebar).toggleClass('sidebar--collapsed sidebar--expanded'); // Shows targeted sidebar
      isOverlaySidebar ? $('body').toggleClass('has-sidebar-overlaid') : $('body').removeClass('has-sidebar-overlaid'); // Handles overlay class
      if (isMainSidebar){
        $('body').toggleClass('has-sidebar-expanded has-sidebar-collapsed');
      }
      break;
  }
  $('.navbar-popover').remove(); // Hides notification popover
  var $items = $(sidebar).find('.item');
  if ($(sidebar).hasClass('sidebar--expanded')){
    // Disables tooltips when sidebar is expanded
    $items.each(function () {
      $(this).removeAttr('data-bs-toggle');
    })
  } else {
    // Re-enables tooltips when collapsed
    $items.each(function () {
      $(this).attr('data-bs-toggle', 'tooltip');
    })  
  }
}

const fixActiveItems = () => {
  // Fixes cases where multiple items in sidebar are active
  function match(s1, s2) {
    console.log(s1, s2);
    s1 = s1.replace(/\/$/, '');
    s2 = s2.replace(/\/$/, '');
    var count = 0;
    for(let i in s1) {
        s2.includes(s1[i]) ? count++ : false;
    }
    return count;
  }
  var sidebarItemsActive = $('#sidebar a.active[href]')
  if (sidebarItemsActive.length > 0){
    var mostSpecific = null;
    var highestMatchCount = 0;
    sidebarItemsActive.each( function () {
      var matchCount = match(sts_current_url, $(this).attr('href'));
      if (matchCount > highestMatchCount){
        highestMatchCount = matchCount;
        mostSpecific = $(this);
      }
    });
    $('#sidebar a.active[href]').removeClass('active');
    mostSpecific.addClass('active');
    var stillMultipleActive = $('#sidebar .active').length > 1 ? true : false;
    if (stillMultipleActive){
      // Fix if mostSpecific is not in a dropdown, and other dropdown still remails active
      var activeDropdown = $('#sidebar .item.active.dropdown');
      var mostSpecificInDropdown = mostSpecific.parents('.dropdown').length > 0 ? true : false;
      if (activeDropdown.length > 0 && !mostSpecificInDropdown){
        activeDropdown.removeClass('active').find('.title').removeClass('active');
      }
    }
  };
}


$(() => {
  // fixActiveItems(); // Not required anymore - navigation.class.php matching is improved!
  $(window).on('resize', function (){
    let windowSize = window.innerWidth;
    if (windowSize <= 1550){
      toggleSidebar('#sidebar', 'hide');
    }
    // else {
    //   if (sidebarDefaultMode === 'expanded') toggleSidebar('#sidebar', 'show');
    // }
  });
  $('.sidebar .item:not(.dropdown)').click( function (e) {
    e.stopPropagation();
    if (isMobile()){
      $(this).toggleClass('active');
    }
    $(this).toggleClass('highlight')
  })
  $('[sidebar-toggle]').click( function () {
    var targetSidebar = $(this).attr('sidebar-toggle');
    // console.log(targetSidebar);
    $(this).toggleClass('expanded');
    toggleSidebar(targetSidebar);
  });
  $('.sidebar-toggle-right').click( function () {
    toggleSidebar('#user-sidebar');
  });
  $('.body-overlay').click( () => {
    // Clicking overlay, hide all overlay sidebars
    toggleSidebar('.sidebar--overlay', 'hide');
  });
  $('.sidebar-toggle-left').click( function () {
    $(this).toggleClass('active');
    toggleSidebar();
    // $(this).css({'opacity': '0'}).delay(50).animate({opacity:1});
  });
  $(document).on('click', '#sidebar.sidebar--collapsed .sidebar-search', function () {
    toggleSidebar('#sidebar', 'show');
    $('.sidebar-search #sidebar-search').focus();  
  });

  var sidebarDefaultMode = $('body').attr('data-sidebar-default-mode');
  let windowSize = window.innerWidth;
  if (windowSize <= 1200){
    toggleSidebar('#sidebar', 'hide');
  }
  // if (sidebarDefaultMode === 'expanded'){
  //   if (isWidescreen()){
  //     $('.sidebar .item.dropdown.active-on-load').removeClass('active-on-load').addClass('active');
  //   }
  // }
  // $('.sidebar .item.dropdown.active-on-load').removeClass('active-on-load').addClass('highlight');

  $('.item.dropdown button.title').click( function () {
    var $sidebar = $(this).parents('.sidebar');
    var $dropdown =  $(this).parents('.item.dropdown');
    var isActive = $dropdown.hasClass('active');
    // $sidebar.find('.dropdown.active').removeClass('active'); // Toggle all other active dropdowns
    // $sidebar.find('.dropdown.highlight').removeClass('highlight'); // Toggle all other highlighted dropdowns
    // console.log('click', isActive);
    if (isActive){
      // console.log('active', $dropdown)
      $dropdown.removeClass('active');
    } else {
      // console.log('!active', $dropdown)
      // $sidebar.find('.sidebar .dropdown.active').removeClass('active');
      $dropdown.addClass('active');  
    }
  });

  $('#vertical-nav .sidebar-toggle').click( function () {

  });

  $('#sidebar #sidebar-search').on("keyup", function() {
    var value = $(this).val() ? $(this).val().toLowerCase() : '';
    var hasResults = 0;
    // console.log('keyup, value length : ', value.length, value);
    $("#sidebar .sidebar-wrapper a.item:not(.dropdown)").filter(function() {
      console.log($(this));
      var span = $(this).find('span.sl').text().toLowerCase();
      var href = null;
      if ($(this)[0].hasAttribute('href')){
        href = $(this).attr('href').toLowerCase();
      }
      // console.log(value, span, href);
      if (span.indexOf(value) == -1 && (typeof href !== null && href.indexOf(value) == -1) ){
        //hides if the search does not match either span, tag or code
        $(this).addClass('d-none');
      } else {
        hasResults = 1;
        $(this).removeClass('d-none');
      }
    }).hide();

    $("#sidebar .sidebar-wrapper .dropdown").filter(function() {
        //console.(this);
        var $dropdown = $(this);
        var title = $(this).find('.title span.sl').text().toLowerCase();
        var items = $(this).find('ul.content>li');
        var titleFoundSearch = (title && title.indexOf(value) !== -1) ? true : false;
        var hasChildrenShown = false;
        $(items).each(function() {
          var $link = $(this).find('a');
          var span = $link.text().toLowerCase();
          var href = $link.attr('href') ? $link.attr('href').toLowerCase() : null;
          var case1 = (span && span.indexOf(value) !== -1) ? true : false;
          var case2 = (href !== null && href.indexOf(value) !== -1) ? true : false;
          if (case1 || case2){
            // If link or text contains search value
            hasChildrenShown = true;
            console.log(title, 'has children ', hasChildrenShown, '| case1 ', case1 , ' case2 ', case2);
            $(this).removeClass('d-none')
          } else {
            $(this).addClass('d-none')
            // console.log($link, span, href, 'showing!');
          }
        });
        if (!title || (!titleFoundSearch && !hasChildrenShown)) {
          // Hide
          $(this).addClass('d-none');
        } else if (titleFoundSearch)  {
          // If search item found in title of dropdown
          // Show all children of dropdown
          console.log(title, ' titleFoundSearch', titleFoundSearch, `(${title}, ${value})`);
          hasResults = 1;
          $dropdown.addClass('active');
          $(this).removeClass('d-none');
          $(items).each(function (){
            $(this).removeClass('d-none');
            $(this).find('.item').removeClass('d-none');
          });
        } else {
          // If search item found in dropdown of menu
          $dropdown.addClass('active');
          hasResults = 1;
          $(this).removeClass('d-none');
        }
    });

    // $('#sidebar .sidebar-wrapper > .dropdown ul>li').filter(function() {
    //   var filterElemSpan = $(this).find('a').text();
    //   if (filterElemSpan.toLowerCase().indexOf(value) == -1){
    //     $(this).addClass('d-none').removeClass('filter-shown');
    //   } else {
    //     $(this).removeClass('d-none').addClass('filter-shown');
    //   }
    // })
    // $('#sidebar .sidebar-wrapper .dropdown-menu-inactive').each( function () {
    //     // showing menus with nested children who match filter
    //     if ($(this).find('.filter-shown').length > 0){
    //         // has children shown
    //         $(this).addClass('has-shown-children');
    //         // $(this).addClass('dropdown-menu-open').find('.content').addClass('active').find('ul').show();
    //     } else {
    //         // has no children shown, hide dropdown
    //         $(this).removeClass('has-shown-children');

    //         // $(this).removeClass('dropdown-menu-open');
    //         // $(this).find('.content').removeClass('active');
    //         // $(this).find('ul').hide();
    //     }
    // });
    if (hasResults === 0){
        $('#no_results').removeClass('d-none');
    } else {
        $('#no_results').addClass('d-none');
    }
    // Expand all dropdowns with shown children
    $('#sidebar .sidebar-wrapper .dropdown.has-shown-children').addClass('dropdown-menu-open').find('.content, .title').addClass('active').find('ul').removeClass('hidden').show();
    // Collapse all dropdowns with no shown children
    $('#sidebar .sidebar-wrapper .dropdown:not(.has-shown-children)').removeClass('dropdown-menu-open').find('.content, .title').removeClass('active').find('ul').addClass('hidden').hide();

    if (value.length > 0){
        $('.clear-search').removeClass('d-none');
    } else {
        $('.clear-search').addClass('d-none');
        $('#sidebar .sidebar-wrapper .dropdown').each( function () {
            // Closes all expanded menus
            // console.log('hiding all');
            $(this).removeClass('active');
            $(this).find('ul').removeClass('hidden');
        });    
    }
    $('#sidebar .sidebar-wrapper section').each( function () {
      var hasVisibleChildren = $(this).find('.dropdown:not(.d-none)').length > 0 || $(this).find('.item:not(.d-none):not(.title--section)').length > 0 ? true : false;
      // console.log('hasVisibleChildren', $(this).find('.title--section').text(), hasVisibleChildren);
      // console.log($(this).find('.dropdown:not(.d-none)'), $(this).find('.item:not(.d-none)'));
      if (hasVisibleChildren){
        $(this).removeClass('d-none');
      } else {
        $(this).addClass('d-none');
      }
    });

  });

  $('.clear-search').click( function () {
      $('#sidebar-search').val('').trigger('keyup');
      $('#sidebar .sidebar-wrapper .dropdown.active').each( function () {
          // Closes all expanded menus
          $(this).removeClass('active').removeClass('has-shown-children');
          $(this).find('ul').addClass('hidden').hide();
      });
  });

  $('#dark_mode').on('change', function () {
    var val = $(this).is(':checked');
    console.log(val);
    if (val == true){
      localStorage.setItem('bluetrait_user_theme', 'dark');
    } else{
      localStorage.removeItem('bluetrait_user_theme');
    }
    $('html').trigger('theme:change');
    $.ajax({
      type: 'POST',
      url: sts_base_url+'/profile/edit',
      dataType: 'json',
      data: {
        'user_theme': val == true ? 'dark' : 'default',
        'save': true,
        'ajax': true
      },
      success: function (response) {
        if (response.message){
        }
      },
      error: function (xhr, status, error) {
        console.log('Error sending Ajax');
        console.log(JSON.stringify(xhr));
        console.log(JSON.stringify(status));
        console.log(JSON.stringify(error));
      }
    });
  })

  $(document).on('theme:change', function () {
    setDarkThemeOnBody();
  });
})